/**
 * 工具类的全局函数定义
 */

// 身份证号前端验证
const identityCodeValid = (code) => {
    return true;
    // let city = {
    //     11: '北京',
    //     12: '天津',
    //     13: '河北',
    //     14: '山西',
    //     15: '内蒙古',
    //     21: '辽宁',
    //     22: '吉林',
    //     23: '黑龙江 ',
    //     31: '上海',
    //     32: '江苏',
    //     33: '浙江',
    //     34: '安徽',
    //     35: '福建',
    //     36: '江西',
    //     37: '山东',
    //     41: '河南',
    //     42: '湖北 ',
    //     43: '湖南',
    //     44: '广东',
    //     45: '广西',
    //     46: '海南',
    //     50: '重庆',
    //     51: '四川',
    //     52: '贵州',
    //     53: '云南',
    //     54: '西藏 ',
    //     61: '陕西',
    //     62: '甘肃',
    //     63: '青海',
    //     64: '宁夏',
    //     65: '新疆',
    //     71: '台湾',
    //     81: '香港',
    //     82: '澳门',
    //     91: '国外 '
    // };
    // let pass = true;
    // if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    //     pass = false;
    // } else if (!city[code.substr(0, 2)]) {
    //     pass = false;
    // } else {
    //     // 18位身份证需要验证最后一位校验位
    //     if (code.length === 18) {
    //         code = code.split('');
    //         // ∑(ai×Wi)(mod 11)
    //         // 加权因子
    //         var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
    //         // 校验位
    //         var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
    //         var sum = 0;
    //         var ai = 0;
    //         var wi = 0;
    //         for (var i = 0; i < 17; i++) {
    //             ai = code[i];
    //             wi = factor[i];
    //             sum += ai * wi;
    //         }
    //         var last = parity[sum % 11];
    //         if (last.toString() !== code[17].toString()) {
    //             pass = false;
    //         }
    //     } else {
    //         pass = false;
    //     }
    // }
    // return pass;
};

// 手机号验证
const verifyMobile = value => {
    let reg = /^1[3456789]\d{9}$/;
    return reg.test(value);
};

// 判断设备
const judgeDevice = () => {
    let u = navigator.userAgent;
    let isAndroid = u.includes('Android') || u.includes('Linux'); // android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) {
        return 'android';
    } else if (isiOS) {
        return 'ios';
    }
};

// 跳转H5评价页面
const goAppEvaluate = (number, sourceType, evaluateType, title) => {
    let u = judgeDevice();
    let params = {
        number: number,
        sourceType: sourceType,
        evaluateType: evaluateType,
        title: title
    };
    if (u === 'android') {
        window.android.goAppEvaluate(JSON.stringify(params));
    } else if (u === 'ios') {
        try {
            window.webkit.messageHandlers.goAppEvaluate.postMessage(params);
        } catch (e) {
            console.log(e);
        }
    }
};

const jumpToPageByApp = (path, params) => {
    let u = judgeDevice();
    let url = path + '?';
    if (params) {
        for (let key in params) {
            if (!url.endsWith('?')) url += '&';
            url += key + '=' + params[key];
        }
    }
    console.log(url);
    if (u === 'android') {
        window.android.jumpToPageByApp(url);
    } else if (u === 'ios') {
        try {
            window.webkit.messageHandlers.jumpToPageByApp.postMessage(url);
        } catch (e) {
            console.log(e);
        }
    }
};

// 拨打电话
const handleAppTel = value => {
    let u = judgeDevice();
    if (u === 'android') {
        window.android.callDriver(value);
    } else if (u === 'ios') {
        try {
            window.webkit.messageHandlers.callDriver.postMessage(value);
        } catch (e) {
            console.log(e);
        }
    }
};

// 打印标签
const handlePrintLabel = value => {
    let u = judgeDevice();
    if (u === 'android') {
        window.android.printLabel(value);
    } else if (u === 'ios') {
        try {
            window.webkit.messageHandlers.printLabel.postMessage(value);
        } catch (e) {
            console.log(e);
        }
    }
};

// umeng埋点
const createUmengEvent = value => {
    let u = judgeDevice();
    if (u === 'android') {
        window.android.createUmengEvent(JSON.stringify(value));
    } else if (u === 'ios') {
        try {
            window.webkit.messageHandlers.createUmengEvent.postMessage(value);
        } catch (e) {
            console.log(e);
        }
    }
};

const callAPP = (event, params = {}) => {
    let u = judgeDevice();
    if (window.JMChannel) {
        console.log('JMChannel', event, params);
        window.JMChannel.postMessage(JSON.stringify({event, params}));
    } else if (u === 'android' && window.android && window.android[event]) {
        console.log('android', event, params, JSON.stringify(params));
        window.android[event](JSON.stringify(params));
    } else if (u === 'ios' && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[event]) {
        console.log('ios', event, params);
        try {
            window.webkit.messageHandlers[event].postMessage(params);
        } catch (e) {
            console.log(e);
        }
    } else {
        if (event === 'tel') {
            window.location.href = `tel:${params.number}`;
        } else {
            console.log('未配置该事件', u);
        }
    }
};

// 定义外部输出
export default {
    identityCodeValid,
    verifyMobile,
    judgeDevice,
    handleAppTel,
    goAppEvaluate,
    jumpToPageByApp,
    handlePrintLabel,
    createUmengEvent,
    callAPP
};



// WEBPACK FOOTER //
// ./src/config/tools.js